var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('select-base',{ref:"selectBase",staticClass:"square-select line-height-default",attrs:{"options":_vm.options,"optionDefault":_vm.optionDefault,"disabled":_vm.disabled},on:{"change":_vm.changeEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }